export default __webpack_public_path__ + "static/media/newsletter-img.44d9c58f.png";